var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtigosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 36.6667C8.50001 36.6667 7.91667 36.4167 7.41667 35.9167C6.91667 35.4167 6.66667 34.8333 6.66667 34.1667V5.83333C6.66667 5.16666 6.91667 4.58333 7.41667 4.08333C7.91667 3.58333 8.50001 3.33333 9.16667 3.33333H30.8333C31.5 3.33333 32.0833 3.58333 32.5833 4.08333C33.0833 4.58333 33.3333 5.16666 33.3333 5.83333V34.1667C33.3333 34.8333 33.0833 35.4167 32.5833 35.9167C32.0833 36.4167 31.5 36.6667 30.8333 36.6667H9.16667ZM9.16667 34.1667H30.8333V5.83333H28.3333V16.9167L24.2917 14.5833L20.25 16.9167V5.83333H9.16667V34.1667ZM9.16667 34.1667V5.83333V34.1667ZM20.25 16.9167L24.2917 14.5833L28.3333 16.9167L24.2917 14.5833L20.25 16.9167V16.9167Z",
    fill: "#337066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtigosIcon);
export default __webpack_public_path__ + "static/media/artigos_icon.021331e19035f3661f54504752f6bd9e.svg";
export { ForwardRef as ReactComponent };